module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-happy-4b4b052d59e5d2147a8c14c67bd1393b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-happy.jpg
// module id = 358
// module chunks = 2